export default __webpack_public_path__ + "static/media/tn-ventas-04-EN.733b9ffa.jpg";